(function() {
  function initSelectors() {
    const wrappers = document.querySelectorAll('.custom-currency-wrapper');
    
    wrappers.forEach(wrapper => {
      const items = wrapper.querySelectorAll('.custom-currency-item');
      const hiddenSelect = wrapper.querySelector('.currency-engine-select');
      const currentText = wrapper.querySelector('.current-currency-text');
      
      function updateUI(value) {
        if (!value) return;
        if (currentText) currentText.textContent = value;
        
        items.forEach(item => {
          if (item.getAttribute('data-value') === value) {
            item.classList.add('is-selected');
          } else {
            item.classList.remove('is-selected');
          }
        });

        if (hiddenSelect) {
          hiddenSelect.value = value;
        }
      }

      // Initial sync
      if (window.CurrencyEngine) {
        updateUI(window.CurrencyEngine.getCurrency());
      }

      // Listen for global currency changes to keep this instance in sync
      document.addEventListener('currency:changed', function(e) {
        updateUI(e.detail);
      });
    });

    // Close dropdowns when clicking outside
    document.addEventListener('click', function() {
      wrappers.forEach(wrapper => {
        wrapper.classList.remove('is-open');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSelectors);
  } else {
    initSelectors();
  }
})();